import React from "react";

import { FormattedDate } from "react-intl";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import Image_ from "../Image";
import LinkComponent, { Link } from "../LinkComponent";
import SmallShapeContainer from "../SmallShapeContainer";

const imageHeight = 150;

const image = css`
    width: 100%;
    height: ${imageHeight}px;
`;

const ImagePlaceholder = styled.div`
    ${image}

    background-color: ${({ theme }) => theme.colors.red.toString()};
`;

const Subline = styled.div`
    font-size: 0.8rem;
`;

const Headline = styled.div`
    margin: 10px 0 20px;
    font-size: 1rem;
    font-weight: 900;
    line-height: 1.2rem;
`;

const LinkItem = styled(Link)`
    width: 100%;
`;

const ItemCard = ({
    item,
    prefix = "blog",
    linkText = "Mehr erfahren",
    width,
}) => {
    return (
        <LinkItem to={`/${prefix}/${item.slug}`}>
            <SmallShapeContainer>
                <SmallShapeContainer.ImageContainer>
                    {item?.image?.src && <Image_ {...item.image} css={image} />}
                    {item?.video?.thumbnail?.src && (
                        <Image_ {...item.video.thumbnail} css={image} />
                    )}
                    {!item?.video?.thumbnail?.src && !item?.image?.src && (
                        <ImagePlaceholder />
                    )}
                </SmallShapeContainer.ImageContainer>

                <SmallShapeContainer.TextContainer>
                    <div>
                        <Subline>
                            <FormattedDate
                                value={
                                    Number(item.datePublished)
                                        ? Number(item.datePublished)
                                        : item.datePublished
                                }
                                format="short"
                            />
                        </Subline>

                        <Headline>{item.title}</Headline>
                    </div>

                    <LinkComponent
                        noLink
                        link={{
                            href: `/${prefix}/${item.slug}`,
                            text: linkText,
                        }}
                        icon="arrow-right"
                    />
                </SmallShapeContainer.TextContainer>
            </SmallShapeContainer>
        </LinkItem>
    );
};
export default ItemCard;
